import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import URLUtils from '../../../util/URLUtils'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const ProjectUpdateUI = ({context, messageList, projectType,
  // project name
  projectName, onProjectNameChange, projectNameError, setProjectNameError,
  // short code
  shortCode, onShortCodeChange, shortCodeError, setShortCodeError,
  // status
  status, statusList, onStatusChange, statusError,
  // visibility
  visibility, visibilityList, onVisibilityChange, visibilityError,
  // project code
  projectCode, onProjectCodeChange, projectCodeError, setProjectCodeError,
  // description
  description, onDescriptionChange, descriptionError, setDescriptionError,
  // announcement
  announcement, onAnnouncementChange, announcementError, setAnnouncementError,
  // form
  onSubmit, submitted, successMsg, errorList, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_update'
      onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      busy={submitted}>
      <InputTextSF type='text' name='projectName' required={true} maxLength={100}
        messageList={messageList} labelKey={projectType === 'project' ? 'c_project_name' : 'c_template_name'}
        value={projectName} onChange={onProjectNameChange}
        error={projectNameError} setError={setProjectNameError}
        autoFocus={true}
      />
      <InputTextSF type='alphanumeric' name='shortCode' required={true} maxLength={5}
        messageList={messageList} labelKey='c_short_code' helpKey='c_shortcode_taskid_tip'
        value={shortCode} onChange={onShortCodeChange}
        error={shortCodeError} setError={setShortCodeError}
      />
      <InputSelectUI name='status' value={status} required={true}
        messageList={messageList} labelKey='c_status'
        optionList={statusList}
        onChange={onStatusChange} error={statusError}
      />
      <InputSelectUI name='visibility' value={visibility} required={true}
        messageList={messageList} labelKey='c_visibility'
        optionList={visibilityList}
        onChange={onVisibilityChange} error={visibilityError}
      />
      {
        visibility === 'all' &&
        <InputTextSF type='text' name='projectCode' required={true} maxLength={40}
          messageList={messageList} labelKey='c_sharable_name'
          help={`${URLUtils.getBaseURL()}/project/${projectCode}`}
          value={projectCode} onChange={onProjectCodeChange}
          error={projectCodeError} setError={setProjectCodeError}
        />
      }
      <InputTextSF type='text' name='description' maxLength={250}
        messageList={messageList} labelKey='c_description' helpKey='c_prj_desc_tip'
        value={description} onChange={onDescriptionChange}
        error={descriptionError} setError={setDescriptionError}
      />
      <InputTextSF type='text' name='announcement' maxLength={250}
        messageList={messageList} labelKey='c_announcement' helpKey='c_prj_announce_tip'
        value={announcement} onChange={onAnnouncementChange}
        error={announcementError} setError={setAnnouncementError}
      />
    </FormSF>
  </CardUI>


export default ProjectUpdateUI
